import React from 'react';
import { Phone, Mail, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';
import { companyInfo } from '../mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold text-amber-400 mb-4">
              {companyInfo.name}
            </h3>
            <p className="text-sm text-gray-400 mb-4">
              {companyInfo.slogan}
            </p>
            <p className="text-sm text-gray-400">
              Kaliteli ve güvenilir mühendislik çözümleri ile yanınızdayız.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-sm hover:text-amber-400 transition-colors">Ana Sayfa</a>
              </li>
              <li>
                <a href="#about" className="text-sm hover:text-amber-400 transition-colors">Hakkımızda</a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-amber-400 transition-colors">Hizmetler</a>
              </li>
              <li>
                <a href="#projects" className="text-sm hover:text-amber-400 transition-colors">Projeler</a>
              </li>
              <li>
                <a href="#contact" className="text-sm hover:text-amber-400 transition-colors">İletişim</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              <li className="text-sm">Betonarme Proje</li>
              <li className="text-sm">Çelik Proje</li>
              <li className="text-sm">Endüstriyel Tesis Projeleri</li>
              <li className="text-sm">Villa Projeleri</li>
              <li className="text-sm">Müşavirlik ve Danışmanlık</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <MapPin size={18} className="text-amber-400 flex-shrink-0 mt-1" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Phone size={18} className="text-amber-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-amber-400 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2 text-sm">
                <Mail size={18} className="text-amber-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-amber-400 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>

            {/* Social Media - Daha sonra doldurulacak */}
            <div className="flex gap-4 mt-4">
              {companyInfo.social.linkedin && (
                <a
                  href={companyInfo.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-amber-400 transition-colors"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
              )}
              {companyInfo.social.instagram && (
                <a
                  href={companyInfo.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-amber-400 transition-colors"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
              )}
              {companyInfo.social.facebook && (
                <a
                  href={companyInfo.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-amber-400 transition-colors"
                  aria-label="Facebook"
                >
                  <Facebook size={20} />
                </a>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            &copy; {currentYear} {companyInfo.name}. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;